import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
  LoadForm,
  IHttpSuccessPayload,
  ILookupResponse,
  HttpRequestPayload,
  IHttpErrorPayload,
} from "@fpx/core";
import { environment } from 'src/environments/environment';
import { PreLoginService } from 'src/app/pre-login/pre-login.service';
import { CommonService } from 'src/app/common.service';

@Injectable()
export class OTPChannelService {
  constructor(private _commonService: CommonService,private httpProvider: HttpProviderService,private _preLoginService: PreLoginService) {}

  fetchOtpChannel(): Observable<any[]> {
    const httpRequest = new HttpRequest();
    httpRequest.setMethod("GET");
    httpRequest.setResource("/otpchannels");
    httpRequest.setServerContext(environment.commonPublisher);
    this._commonService.showSpinner();
    return this.httpProvider.invokeRestApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      this._commonService.hideSpinner();
      let twofactor = this._preLoginService.twoFactor;
      if (response.body) {
        let channelArray = [];
        response.body.forEach(x => {
          if (x.text?.toLowerCase()  == 'email') {
            channelArray.push({ id: x.id, text: x.text + " (" + twofactor.email + ")" });
          }else if (x.text?.toLowerCase()  == 'sms') {
            channelArray.push({ id: x.id, text: x.text + " (" + twofactor.mobile + ")" })
          } else if (x.text?.toLowerCase() == 'whatsapp' && twofactor.whatsapp) {
            channelArray.push({ id: x.id, text: x.text + " (" + twofactor.whatsapp + ")" })
          }
        });
       if(channelArray.length==3){
        const temp = channelArray[1];
        channelArray[1] = channelArray[2];
        channelArray[2] = temp;
       }else{
        const temp = channelArray[0];
        channelArray[0] = channelArray[1];
        channelArray[1] = temp;
       }
        return channelArray;
      }
    },
    catchError((err : IHttpErrorPayload) => {
      this._commonService.hideSpinner();
      return throwError(err)
    })));
  }
}
